import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Banner() {
  // https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/9/1/7adc4452-d970-4d44-a12e-6554271e49d0.jpg.webp?ect=3g
  // https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/9/1/48010c24-457a-4cbf-a138-ff625b16543f.jpg.webp?ect=3g
  // https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/9/1/7adc4452-d970-4d44-a12e-6554271e49d0.jpg.webp?ect=3g

  return (
    <div className="my-8">
      <Carousel
        autoPlay
        infiniteLoop
        showStatus={false}
        showIndicators={true}
        showThumbs={false}
        interval={5000}
      >
        <div>
          <img
            src="https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/9/1/7adc4452-d970-4d44-a12e-6554271e49d0.jpg.webp?ect=3g"
            alt=""
            loading="lazy"
            className="rounded-xl"
          />
        </div>
        <div>
          <img
            src="https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/9/1/48010c24-457a-4cbf-a138-ff625b16543f.jpg.webp?ect=3g"
            alt=""
            loading="lazy"
            className="rounded-xl"
          />
        </div>
        <div>
          <img
            src="https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/9/1/df06118d-407e-41ea-8565-ecbf21400e3f.jpg.webp?ect=3g"
            alt=""
            loading="lazy"
            className="rounded-xl"
          />
        </div>
      </Carousel>
    </div>
  );
}

export default Banner;
